import React, {useEffect, useContext, useState} from 'react';
import {useForm} from 'react-hook-form';
import {TextField, Grid, FormLabel, Button, MenuItem, FormHelperText} from '@material-ui/core';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {Controller} from 'react-hook-form';
import DragAndDrop from './Drag&Drop';
import {
  postClientCode,
  resetClientCodes,
} from '../../../../../redux/reducers/client-maintainance/ClientGeneral';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {postEnableFileFormatImportData} from '../../../../../redux/reducers/EnableFramework/AddEnableFileFormat';
import PageLoader from '../../../../../components/PageLoader';

export default function DetailsForm({jobCode, handleClose}) {
  const [selectedFile, setSelectedFile] = useState('');
  const [clientCodeVal, setClientCodeVal] = useState('');
  const [validation, setValidation] = useState(false);

  const dispatch = useDispatch();
  const initialValues = {
    defaultClientCode: '',
    defaultListDate: null,
  };

  const {isLoading} = useSelector(({addEnableFileFormat}) => addEnableFileFormat);
  const {clientCodeData} = useSelector(({clientGeneral}) => clientGeneral);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [fileValid, setFileValid] = useState(false);

  window.onclick = () => {
    dispatch(resetClientCodes());
  };
  const {reset, handleSubmit, control, setValue} = useForm({
    defaultValues: initialValues,
  });
  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      const reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(file);
      // on reader load somthing...
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };
  useEffect(() => {
    dispatch(resetClientCodes());
  }, []);
  const debounceClientCode = (value) => {
    const data = {
      clientNumber: value,
    };
    if (data?.clientNumber) {
      dispatch(postClientCode(data));
    }
  };
  useEffect(() => {
    const data =
      Object.keys(clientCodeData)?.length > 0 ?
        clientCodeData?.map((item) => item?.clientNumber) :
        [];
    if (clientCodeVal && data?.includes(clientCodeVal)) {
      setClientCodeVal('');
      setValidation(false);
    } else if (!(clientCodeVal && data?.includes(clientCodeVal))) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  }, [clientCodeData]);
  const handleFileInputChange = (e) => {
    const file = selectedFile?.[0];
    getBase64(file)
      .then((result) => {
        file['base64'] = result;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (selectedFile?.[0]) {
      handleFileInputChange();
    }
  }, [selectedFile]);

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append('multipartFile', selectedFile?.[0]);
    formData.append(
      'data',
      new Blob(
        [
          JSON.stringify({
            jobCode: jobCode,
            defaultClientCode: data?.defaultClientCode,
            defaultListDate: data?.defaultListDate,
          }),
        ],
        {type: 'application/json'},
      ),
    );

    !(validation && clientCodeVal) && selectedFile?.[0] && !fileValid && dispatch(postEnableFileFormatImportData(formData));
  };
  return (
    <div className={`col-md-12`}>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="form-row">
          <div className="form-group col-sm-6">
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={` ${classes.labelName} ${classes.inputLabel}`}
                  placeholder="Enter Default Client Code"
                  margin="dense"
                  name="defaultClientCode"
                  value={value}
                  variant="outlined"
                  label="Default Client Code"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={validation && clientCodeVal}
                  onChange={(e) => {
                    onChange(e.target.value);
                    setClientCodeVal(e.target.value);
                    setValue('defaultClientCode', e.target.value);
                    if (e.target.value) {
                      debounceClientCode(e.target.value);
                    } else if (e.target.value === '') {
                      dispatch(resetClientCodes());
                    }
                  }}
                  fullWidth
                />
              )}
              control={control}
              name="defaultClientCode"
            />
            {validation && clientCodeVal ? (
              <FormHelperText style={{color: 'red'}} variant="outlined">
                Client Code does not exist
              </FormHelperText>
            ) : null}
            <div className="parentclient-popover">
              {clientCodeData?.length > 0 &&
                clientCodeData?.map((data, i) => (
                  <MenuItem
                    key={i}
                    onClick={() => {
                      setClientCodeVal('');
                      setValidation(false);
                      setValue('defaultClientCode', data.clientNumber);
                    }}
                  >
                    {data.clientNumber}
                  </MenuItem>
                ))}
            </div>
          </div>
          <div className="form-group col-sm-6">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container>
                <Controller
                  as={
                    <KeyboardDatePicker
                      className={`${classes.datePicker} ${classes.labelName}`}
                      orientation="portrait"
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  }
                  name="defaultListDate"
                  inputVariant="outlined"
                  control={control}
                  label="Default List Date"
                  onChange={(date) => {
                    setValue('defaultListDate', date);
                    return {value: date};
                  }}
                  autoOk
                  margin="dense"
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </div>
          <div className={`${classes.DragAndDropWrapper} col-sm-12 mt-3 form-group`}>
            <FormLabel className={`${classes.legend} ${classes.radioGroup}`}>
              Upload a file
            </FormLabel>
            <div className={``}>
              <DragAndDrop
                fileValid={fileValid}
                setFileValid={setFileValid}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                oldFile={[selectedFile?.[0]?.name ? selectedFile?.[0]?.name : '']}
              />
            </div>
          </div>
        </div>
        <div className="button-spacing-mb">
          <Button
            type="reset"
            onClick={() => {
              reset(initialValues);
              setClientCodeVal('');
              setValidation(false);
              setSelectedFile([]);
              setFileValid(false);
            }}
            variant="contained"
            className={`mx-1 ${classes.buttonRoot}`}
          >
            Cancel
          </Button>
          <Button
            type={'submit'}
            variant="contained"
            // onClick={() => {
            //   setSubmit(true);
            //   console.log(validation ? "button" : "submit", validation);
            // }}
            className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
          >
            Save
          </Button>
        </div>
        {isLoading && <PageLoader />}
      </form>
    </div>
  );
}
